/* ============================================================================
   NEXT Hub — Shared global chrome (announcement bar + header + footer).
   PORTS TO SHOPIFY: this maps to header-group.json + footer-group.json (the
   globally-injected section groups). In the HTML mockup we inject it with JS so
   every page stays in sync from one source. Each page sets window.NEXTHUB_PAGE
   (e.g. 'education') before loading this script to flag the active nav item, and
   includes <div id="nh-header"></div> / <div id="nh-footer"></div> mount points.

   LINKS: point at local -v1.html files so the mockup is fully clickable for review.
   On port these become Shopify routes: home '/', education '/pages/education',
   corporate '/pages/corporate', software '/pages/software', faq '/pages/faq',
   calculator '/pages/savings-calculator', PDPs '/products/...'.
   ============================================================================ */
(function () {
  function NHA(f){ return (window.NEXTHUB_ASSETS && window.NEXTHUB_ASSETS[f]) || ('assets/img/' + f); }
  var LOGO = "https://store.next-hub.com/cdn/shop/files/CT24_NEXTHub_Logo_Horizontal-Color.png?v=1767091960";

  // page key -> Shopify route
  var R = {
    home: "/",
    education: "/pages/education",
    corporate: "/pages/corporate",
    software: "/pages/software",
    faq: "/pages/faq",
    calculator: "/pages/savings-calculator",
    hub: "/products/next-hub-display-upgrade-solution",
    mic: "/products/next-3-in-1-microphone-system",
    fobio: "/products/next-fobio",
    connect: "/pages/connect",
    contact: "/pages/contact",
    demo: "/pages/book-a-demo"   // two-step booking page (CLEAR-209); contact stays the contact form
  };

  var active = window.NEXTHUB_PAGE || "";
  function cur(key) { return active === key ? ' aria-current="page"' : ""; }

  /* ---- announcement bar (no emoji — SVG gift icon) ---- */
  var GIFT = '<svg class="ic-inline" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v9h14v-9M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8M16.5 8a2.5 2.5 0 0 0 0-5C13 3 12 8 12 8"/></svg>';
  var announce =
    '<div class="announce">' +
      '<span class="gift">' + GIFT + '</span>' +
      '<span>Get a <strong>FREE 3-in-1 Mic Kit ($499 value)</strong> with every NEXT Hub &nbsp;·&nbsp; Free shipping on 5+ units</span>' +
      '<a href="' + R.calculator + '">Calculate your savings →</a>' +
    '</div>';

  /* ---- AWARDS (Raj: revolving showcase, no emojis) — Jenn's real 2024 award badges ---- */
  var AWARDS = [
    { name: "Best of Show", cat: "ISTE 2024 · Tech &amp; Learning", img: NHA("award-iste.png") },
    { name: "Best of Show", cat: "ISE 2024 · Tech &amp; Learning", img: NHA("award-ise.png") },
    { name: "Best of Show", cat: "InfoComm 2024 · Sound &amp; Video Contractor", img: NHA("award-infocomm.png") },
    { name: "Breakthrough Award", cat: "EdTech 2024 · Education Hardware", img: NHA("award-edtech.png") },
    { name: "Learning by Design", cat: "EdSpaces 2024 · Product Innovation", img: NHA("award-edspaces.png") }
  ];
  function awardsHTML() {
    var card = function (a) {
      return '<div class="aw-card"><div class="aw-badge aw-badge-img"><img src="' + a.img + '" alt="' + a.name + ' — ' + a.cat + '" loading="lazy" /></div>' +
        '<div><div class="aw-name">' + a.name + '</div><div class="aw-cat">' + a.cat + '</div></div></div>';
    };
    var items = AWARDS.concat(AWARDS).concat(AWARDS).map(card).join(""); // tripled for a seamless loop
    return '<div class="awards-band" aria-label="Awards and certifications">' +
      '<div class="wrap-wide"><div class="aw-kicker">Award-winning &amp; certified · A Clear Touch® × NUITEQ® collaboration</div></div>' +
      '<div class="aw-rail"><div class="aw-track">' + items + '</div></div>' +
    '</div>';
  }

  /* ---- header ---- */
  var header =
    '<header class="site">' +
      '<nav class="nav" aria-label="Primary">' +
        '<a class="logo" href="' + R.home + '" aria-label="NEXT Hub home"><img src="' + LOGO + '" alt="NEXT Hub" /></a>' +
        '<ul>' +
          // Shop mega dropdown with real product images (design-lift)
          '<li class="nh-has-mega"><a href="' + R.hub + '">Shop</a>' +
            '<div class="nh-mega">' +
              '<a class="nh-mega-card" href="' + R.hub + '"><img src="https://store.next-hub.com/cdn/shop/files/NT24_NEXT-Promethean-panel_8ad87cce-5b74-41fa-8148-03bedbb41157.png?v=1768879920" alt="" /><span><b>NEXT Hub Upgrade</b>$1,399 · <span class="free">free mic</span></span></a>' +
              '<a class="nh-mega-card" href="' + R.mic + '"><img src="https://cdn.shopify.com/s/files/1/0745/4372/6780/files/CT23_Collar-Mic-Handheld-1200px_1.png?v=1779995365" alt="" /><span><b>3-in-1 Microphone</b>$499 · <span class="free">free with Hub</span></span></a>' +
              '<a class="nh-mega-card" href="' + R.fobio + '"><img src="' + NHA("fobio-fob.png") + '" alt="" /><span><b>NEXT FOBio</b>$89.99 · <span class="free">/ pack of 6</span></span></a>' +
            '</div>' +
          '</li>' +
          '<li><a href="' + R.education + '"' + cur("education") + '>For Schools</a></li>' +
          '<li><a href="' + R.corporate + '"' + cur("corporate") + '>For Corporate</a></li>' +
          '<li><a href="' + R.software + '"' + cur("software") + '>Software</a></li>' +
          '<li><a href="' + R.faq + '"' + cur("faq") + '>FAQ</a></li>' +
        '</ul>' +
        '<span class="spacer"></span>' +
        '<div class="nav-cta">' +
          '<a href="' + R.demo + '" class="btn btn-secondary nh-demo-cta">Book a Demo</a>' +
          '<a href="' + R.calculator + '" class="btn btn-primary">Calculate Savings</a>' +
          // Cart is first-class — this is a store (architecture: rebalanced CTA hierarchy)
          '<button class="nh-cart-btn" aria-label="Open cart" onclick="window.NHcart&&NHcart.open()">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6h15l-1.5 9h-12z"/><path d="M6 6 5 2H2"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/></svg>' +
            '<span class="nh-cart-count">0</span>' +
          '</button>' +
        '</div>' +
        '<button class="menu-toggle" aria-label="Menu" onclick="document.body.classList.toggle(\'nh-nav-open\')">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="#161616" stroke-width="2"><path d="M3 6h18M3 12h18M3 18h18"/></svg>' +
        '</button>' +
      '</nav>' +
    '</header>';

  /* ---- footer ---- */
  var footer =
    '<footer class="site">' +
      '<div class="wrap-wide">' +
        '<div class="foot-grid">' +
          '<div>' +
            '<a class="logo" href="' + R.home + '"><img src="' + LOGO + '" alt="NEXT Hub" /></a>' +
            '<p>Upgrade aging interactive displays to Android 15 + Google — instead of replacing them. A Clear Touch® × NUITEQ® collaboration.</p>' +
          '</div>' +
          '<div><h4>Product</h4><ul>' +
            '<li><a href="' + R.hub + '">NEXT Hub Upgrade</a></li>' +
            '<li><a href="' + R.mic + '">3-in-1 Microphone</a></li>' +
            '<li><a href="' + R.fobio + '">FOBio</a></li>' +
            '<li><a href="' + R.software + '">NUITEQ Software</a></li>' +
          '</ul></div>' +
          '<div><h4>Explore</h4><ul>' +
            '<li><a href="' + R.calculator + '">Savings Calculator</a></li>' +
            '<li><a href="' + R.education + '">For Schools</a></li>' +
            '<li><a href="' + R.corporate + '">For Corporate</a></li>' +
            '<li><a href="' + R.connect + '">Connect</a></li>' +
            '<li><a href="' + R.faq + '">FAQ</a></li>' +
          '</ul></div>' +
          '<div><h4>Contact</h4>' +
            '<div class="foot-contact">' +
              '<a href="' + R.contact + '">Contact us</a><br />' +
              '<a href="' + R.demo + '">Book a free demo</a><br />' +
              '<a href="mailto:info@getcleartouch.com">info@getcleartouch.com</a><br />' +
              'Mon–Fri, 8am–6pm ET' +
            '</div>' +
            '<ul style="margin-top:16px;"><li><a href="#">Data-Sharing Opt-Out</a></li></ul>' +
          '</div>' +
        '</div>' +
        '<div class="foot-bottom">' +
          '<span>© 2026 NEXT Hub. A Clear Touch® × NUITEQ® collaboration.</span>' +
          '<span>Android, Google Play and Google apps are trademarks of Google LLC. EDLA-certified. *Some units may ship with Android 13 and update to Android 15.</span>' +
        '</div>' +
      '</div>' +
    '</footer>';

  function loadCart() {
    if (window.NHcart || document.getElementById("nh-cart-js")) return;
    var s = document.createElement("script");
    s.src = "assets/nexthub-cart.js"; s.id = "nh-cart-js";
    document.body.appendChild(s);
  }

  function mount() {
    var h = document.getElementById("nh-header");
    var f = document.getElementById("nh-footer");
    if (h) h.outerHTML = announce + header;
    if (f) f.outerHTML = footer;
    document.querySelectorAll("#nh-awards").forEach(function (el) { el.outerHTML = awardsHTML(); });
    loadCart();
    initReveal();
    initDemoCta();
    initMobileShop();
  }

  /* On mobile, the "Shop" link should expand the product mega (Hub / Mic / FOBio)
     as an accordion instead of jumping straight to the Hub PDP. Desktop keeps the
     hover dropdown + normal navigation. */
  function initMobileShop() {
    var parent = document.querySelector(".nh-has-mega");
    if (!parent) return;
    var link = parent.querySelector("a");
    if (!link || link.dataset.nhMegaBound) return;
    link.dataset.nhMegaBound = "1";
    link.addEventListener("click", function (e) {
      if (window.matchMedia && window.matchMedia("(max-width: 980px)").matches) {
        e.preventDefault();
        parent.classList.toggle("nh-mega-open");
      }
    });
  }

  /* "Book a Demo" CTA → the two-step booking page (CLEAR-209). Every .nh-demo-cta
     routes to R.demo so demo buttons sitewide land on the booking flow. The contact
     page was retired (hidden, 7/20) and the legacy /pages/demo is being redirected,
     so ANY anchor still pointing at either — footer link, section CTA, or a
     customizer-stored setting we can't grep — gets rewritten to R.demo too.
     Stays a real <a> for a11y. */
  function initDemoCta() {
    var DEST = R.demo && R.demo !== "#" ? R.demo : R.contact;
    document.querySelectorAll('.nh-demo-cta, a[href^="/pages/contact"], a[href^="/pages/demo"]').forEach(function (a) {
      if (a.dataset.nhDemoBound) return;
      a.dataset.nhDemoBound = "1";
      a.setAttribute("href", DEST);
    });
  }

  /* In-view scroll reveal (design-lift). Progressive enhancement: only hides if JS+IO run. */
  function initReveal() {
    if (!("IntersectionObserver" in window)) return;
    var els = document.querySelectorAll("section, .awards-band");
    els.forEach(function (el) { el.classList.add("nh-reveal"); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("nh-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }
})();
